import React, { FC, LegacyRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slick, { Settings } from "react-slick";
import classNames from "classnames";

export interface SliderProps extends React.HTMLAttributes<HTMLElement> {
  innerRef?: LegacyRef<Slick>;
  options?: Settings;
}

export const Slider: FC<SliderProps> = ({
  children,
  options,
  className,
  innerRef,
}) => {
  const settings: Settings = {
    className: classNames(
      "slider variable-width",
      "[&>div>div]:flex [&>div>div>div>div]:my-0 [&>div>div>div>div]:mx-4 [&>div>div>div>div]:md:mx-10",
      className,
    ),
    dots: false,
    arrows: false,
    ...options,
  };

  return (
    <Slick ref={innerRef} {...settings}>
      {children}
    </Slick>
  );
};
